import axios from "axios"
import moment from "moment"
import { EventRegister } from 'react-native-event-listeners';
import { Api, BrigoshaMedia, Notification } from 'services';
import {
  updateRoomName,
  updateConfId,
  updateRoomUsers,
  getPreviousChat,
  updateClassJoin,
  setLiveClass,
  resetHandRaiseQ,
  clearPages,
  toggleChatLoader,
  updateChats,
  updateHandRaiseQ,
  updateClassMode,
  updateMyHandRaise,
  updateInHandRaiseQ,
} from 'actions/liveClass';
import initListeners from 'actions/listener';
import { updateConnectionState } from 'actions/brigoshaMedia';
import { copyChats, getRoomData, setLocalRecordingName, setBroadcastLoader, setRightView, setRightViewType, setRoomBoardData, setScheduledTeacher, updateUnreadCount, updateUserList } from "./broadcast"
import { fake_OrgData } from "pages/conference/fakedata";
import { getSchedulePermissions } from "pages/schedule/schedulePermissions";

export const SET_SUBJECT = "SET_SUBJECT"
export const SET_CLASS = "SET_CLASS"
export const SET_TEACHER = "SET_TEACHER"
export const SET_START_TIME = "SET_START_TIME"
export const SET_END_TIME = "SET_END_TIME"
export const SET_START_DATE = "SET_START_DATE"
export const SET_MODE = "SET_MODE"
export const SET_END_DATE = "SET_END_DATE"
export const SET_WEEKDAYS = "SET_WEEKDAYS"
export const GET_SUB_LIST = "GET_SUB_LIST"
export const GET_CLASS_LIST = "GET_CLASS_LIST"
export const GET_TEACHER_LIST = "GET_TEACHER_LIST"
export const GET_SCHEDULE_LIST = "GET_SCHEDULE_LIST"
export const GET_SUMMARY_DATA = "GET_SUMMARY_DATA"
export const GET_TIMETABLE_DATA = "GET_TIMETABLE_DATA"
export const GET_STD_LIST_FILTER = "GET_STD_LIST_FILTER"
export const SET_STD_FILTER = "SET_STD_FILTER"
export const GET_TODAY_ACTIVITIES_DATA = "GET_TODAY_ACTIVITIES_DATA"
export const GET_SUB_LIST_FILTER = "GET_SUB_LIST_FILTER"
export const SET_SCHEDULE_ID = "SET_SCHEDULE_ID"
export const SET_SCHEDULE_TIMETABLE = "SET_SCHEDULE_TIMETABLE"
export const SET_MONTH_OR_WEEK = "SET_MONTH_OR_WEEK"
export const SET_START_DATE_SCHEDULE = "SET_START_DATE_SCHEDULE"
export const SET_END_DATE_SCHEDULE = "SET_END_DATE_SCHEDULE"
export const SET_TAB_TYPE = "SET_TAB_TYPE"
export const SET_STD_FILTER_TIMETABLE = "SET_STD_FILTER_TIMETABLE"
export const UPDATE_ERROR = "UPDATE_ERROR"
export const SET_BROADCAST_SELECTED_CLASSROOM = "SET_BROADCAST_SELECTED_CLASSROOM"
export const SET_ROOM_IDS = "SET_ROOM_IDS"
export const GET_ONLINE_USER = "GET_ONLINE_USER"
export const SET_ACCESS = "SET_ACCESS"
export const SET_DEL_OR_CANCEL = "SET_DEL_OR_CANCEL"
export const UPDATE_BROADCAST_STUDENT_LIST = "UPDATE_BROADCAST_STUDENT_LIST"
export const SET_JOIN_LOADER = "SET_JOIN_LOADER"

export const SET_CURRENT_DATE = 'SET_CURRENT_DATE'
export const GET_MODES = 'GET_MODES'
export const SET_TEACHER_FILTER = 'SET_TEACHER_FILTER'
export const SET_CLASS_FILTER = 'SET_CLASS_FILTER'
export const SET_SUB_FILTER = 'SET_SUB_FILTER'
export const SET_PAGE_TOGGLE = 'SET_PAGE_TOGGLE'


// schedule attendance
export const SET_STUDENT_DATA = 'SET_STUDENT_DATA'
export const SET_SUBJECT_DATA = 'SET_SUBJECT_DATA'
export const SET_SELECTED_STUDENTS = 'SET_SELECTED_STUDENTS'
export const SET_SELECT_ALL = 'SET_SELECT_ALL'
export const SET_CHECKBOX_STATE = 'SET_CHECKBOX_STATE'
export const SET_SELECTED_ID = 'SET_SELECTED_ID'
export const SET_PRESENT_STUDENTS = 'SET_PRESENT_STUDENTS'
export const SET_CARD_DATA = 'SET_CARD_DATA'
export const SET_SELECTED_STUDENTS_CLEAR = 'SET_SELECTED_STUDENTS_CLEAR'
export const SET_ALL_FALSE = 'SET_ALL_FALSE'
export const SET_ATTENDANCE_THRESHOLD = 'SET_ATTENDANCE_THRESHOLD'
export const SET_INITIAL_SUMMARY = 'SET_INITIAL_SUMMARY'
export const SET_TEACHER_DATE = 'SET_TEACHER_DATE'
export const FETCH_SUBSALERT_DATA = 'FETCH_SUBSALERT_DATA'
export const SET_STUDENT_LIST_LOADING = 'SET_STUDENT_LIST_LOADING'
export const DRAWER_BOOLEAN_STATE = 'DRAWER_BOOLEAN_STATE'

export const setStudentListLoading = (bool) => ({
  type: SET_STUDENT_LIST_LOADING,
  bool,
})

export const UPDATE_SCHEDULE = 'UPDATE_SCHEDULE';

export const TOGGLE_LOADER = 'TOGGLE_LOADER';

export const UPDATE_MEET_DETAILS = 'UPDATE_MEET_DETAILS';

export const UPDATE_ZOOM_TOKEN = 'UPDATE_ZOOM_TOKEN';

export const UPDATE_START_LOADER_TEXT = 'UPDATE_START_LOADER_TEXT';

export const UPDATE_START_LOADER = 'UPDATE_START_LOADER';

export const UPDATE_ACTIVE_CLASS = 'UPDATE_ACTIVE_CLASS';

export const TOGGLE_SCHEDULE_REFRESH = 'TOGGLE_SCHEDULE_REFRESH';

export const TOGGLE_ZOOM_STATUS = 'TOGGLE'

export const SET_CONFERENCE_JOIN_LOADER = 'SET_CONFERENCE_JOIN_LOADER'

export const STUDENT_STANDARD_FILTER = 'STUDENT_STANDARD_FILTER'

export const SET_RECORD_COUNT = 'SET_RECORD_COUNT'
export const SET_LIVE_STREAM_URL = 'SET_LIVE_STREAM_URL'
export const SET_SUBSCRIPTION_MODAL = 'SET_SUBSCRIPTION_MODAL'

export const toggleRefresh = value => ({
  type: TOGGLE_SCHEDULE_REFRESH,
  value,
});

export const updateActiveClass = value => ({
  type: UPDATE_ACTIVE_CLASS,
  value,
});

export const updateStartLoader = value => ({
  type: UPDATE_START_LOADER,
  value,
});

export const updateStartLoaderText = value => ({
  type: UPDATE_START_LOADER_TEXT,
  value,
});

export const updateZoomToken = token => ({
  type: UPDATE_ZOOM_TOKEN,
  token,
});

export const toggleLoader = res => ({
  type: TOGGLE_LOADER,
  res,
});

export const updateSchedule = (res, date) => ({
  type: UPDATE_SCHEDULE,
  res,
  date,
});

export const updateMeetDetails = res => ({
  type: UPDATE_MEET_DETAILS,
  res,
});

export const drawerBooleanState = value => ({
  type: DRAWER_BOOLEAN_STATE,
  value,
});
export const getSchedule =
  (date, standardId = null) =>
    dispatch => {
      const params = {
        date,
        standardId,
      };
      return Api.get('/schedule-new/filter-schedule')
        .params(params)
        .send(response => {
          dispatch(toggleLoader(false));
          dispatch(toggleRefresh(false));
          if (typeof response !== 'undefined') {
            let newResponse = {
              ongoing: response.ongoing.filter((item) => {
                if (item.mode === 'Zoom 40') {
                  return false
                }
                return true
              }),
              completed: response.completed.filter((item) => {
                if (item.mode === 'Zoom 40') {
                  return false
                }
                return true
              }),
              cancelled: response.cancelled.filter((item) => {
                if (item.mode === 'Zoom 40') {
                  return false
                }
                return true
              }),
              scheduled: response.scheduled.filter((item) => {
                if (item.mode === 'Zoom 40') {
                  return false
                }
                return true
              })
            }
            dispatch(
              updateSchedule(
                [
                  ...newResponse.completed,
                  ...newResponse.ongoing,
                  ...newResponse.scheduled,
                ],
                date,
              ),
            );
            // if (newResponse.ongoing.length) {
            //   dispatch(getOnlineCount(newResponse.ongoing));
            // }
          }
        });
    };


export const startClass =
  (scheduleId, isZoom = false, history) =>
    (dispatch, getState) => {
      const { user } = getState().session;
      const { roomName } = getState().liveClass;
      dispatch(updateStartLoaderText('Joining your classroom...'));
      dispatch(updateStartLoader(true));

      return new Promise((resolve, reject) => {
        return Api.patch(`/schedule-new/join-class?id=${scheduleId}`).send(
          response => {
            if (typeof response !== 'undefined') {
              resolve();
              if (roomName !== response.roomName) {
                dispatch(setLiveClass());
                dispatch(clearPages());
              }
              dispatch(updateConfId(response?.occurance?.id));
              dispatch(updateClassMode(response?.occurance?.mode));
              if (isZoom) {
                dispatch(updateClassJoin(true));
                dispatch(updateStartLoader(false));
                return;
              }
              dispatch(resetHandRaiseQ());
              // add teacher to room users array. for offline list
              response.occurance.teacher.isTeacher = true;
              response.students.unshift(response.occurance.teacher);
              dispatch(updateRoomUsers(response.students, user.id));
              dispatch(updateRoomName(response?.occurance?.roomName));
              dispatch(onClassJoin(user, response?.occurance?.roomName, history));
            } else {
              dispatch(setConferenceJoinLoader(false));
              reject();
              dispatch(updateStartLoader(false));
            }
          },
        );
      });
    };

export const onClassJoin = (user, roomName, history) => async (dispatch, getState) => {
  dispatch(connectMedia(user, roomName, history));
  dispatch(updateClassJoin(true));
  dispatch(getPreviousChat(roomName));
};

export const connectMedia = (user, roomName, history) => (dispatch, getState) => {
  const { activeClass } = getState().schedule;
  const { currentClassMode } = getState().liveClass;
  const isTeacher = user.isAdmin || user.isSuperAdmin || user.isPlanner || user.isAttendanceMarker ? activeClass.teacherId === user.id : activeClass.teacher.id === user.id;
  const platform = 'web';
  user.roomId = roomName;
  user.platform = platform;

  const media = new BrigoshaMedia();
  let newuser = {
    ...user,
    isTeacher: isTeacher,
    // org: fake_OrgData
  }
  media.init(
    user.id,
    roomName,
    user.name,
    newuser,
    isTeacher,
    platform,
    currentClassMode,
  );

  dispatch(initListeners(user, isTeacher, history));

  EventRegister.addEventListener('joinRcv', data => {
    const { currentClassMode } = getState().liveClass;
    if (currentClassMode == 'Offline') {
      dispatch(updateStartLoader(false));
      // RootNavigation.navigate('OfflineChat');
    }
    // inform brigosha media that you are in class
    media.updateClassJoinStatus(true);
    if (data.handRaiseQueue.length) {
      dispatch(updateHandRaiseQ(data.handRaiseQueue));
    }
    if (data.url) {
      media.setBaseUrl("https://livestream.aulas.in/api");
    }
    // if user is already in handRaiseQ, enable audio/video
    if (data.handRaiseStatus) {
      dispatch(updateMyHandRaise(true));
      dispatch(updateInHandRaiseQ(true));
    }
    dispatch(updateConnectionState(false));
  });

  EventRegister.addEventListener('settingupServerRcv', () => {
    dispatch(updateStartLoaderText('Setting up your shiny new classroom...'));
  });

  EventRegister.addEventListener('serverInitialized', () => {
    media.initSockets(true);
  });
};

export const sendZoomCode = code => (dispatch, getState) => {
  const params = {
    code,
  };
  dispatch(updateStartLoader(true));
  return new Promise(resolve => {
    Api.get('/schedule-new/fetch-token')
      .params(params)
      .send(response => {
        dispatch(updateStartLoader(false));
        resolve(response?.message);
      });
  });
};

export const getZoomUser = () => (dispatch, getState) => {
  dispatch(updateStartLoader(true));
  return new Promise((resolve, reject) => {
    Api.get('/schedule-new/fetch-zoom-user').send(response => {
      dispatch(updateStartLoader(false));
      if (typeof response !== 'undefined') {
        resolve(response);
      }
    });
  });
};


export const fetchSubList = (search, callback) => {
  return (dispatch) => {
    const url = `/schedule-new/subject-list?search=${search ? search : ''}`
    return new Promise((resolve, reject) => {
      Api.get(url)
        .send((response, error) => {
          if (callback) {
            callback()
          }
          if (response != undefined) {
            dispatch(getSubList(response))
          }
        })
    })
  }
}

export const fetchClassList = (search, subId, callback) => {
  return (dispatch) => {
    const url = `/schedule-new/standard-list?search=${search ? search : ''}&subjectId=${subId ? subId : ''}`
    return new Promise((resolve, reject) => {
      Api.get(url)
        .send((response, error) => {
          if (callback) {
            callback()
          }
          if (response != undefined) {
            dispatch(getClassList(response))
          }
        })
    })
  }
}

export const fetchTeacherList = (search, callback) => {
  return (dispatch) => {
    const url = `/schedule-new/teacher-list?search=${search ? search : ''}`
    return new Promise((resolve, reject) => {
      Api.get(url)
        .send((response, error) => {
          if (callback) {
            callback()
          }
          if (response != undefined) {
            dispatch(getTeacherList(response))
          }
        })
    })
  }
}

export const postCreateSchedule = (objectSchedule, callback, successCallback) => {
  return (dispatch) => {
    const url = `/schedule-new/`
    return new Promise((resolve, reject) => {
      Api.post(url, objectSchedule)
        .send((response, error) => {
          if (response != undefined) {
            if (response.show.type == 'error') {
              callback()
            }
            else {
              successCallback()
            }
          }
          else {
            callback()

          }
        })
    })
  }
}

export const fetchSchedule = (callback, date) => {
  return (dispatch, getState) => {
    // const { date } = getState().schedule;
    const url = `/schedule-new/`
    return new Promise((resolve, reject) => {
      Api.get(url)
        .send((response, error) => {
          if (callback) {
            callback()
          }
          if (response != undefined) {
            dispatch(getStdListFilter(response.standards))
            dispatch(getSubListFilter(response.subjects))
            dispatch(getSchedules(response.schedules))
            dispatch(getTodayactivitiesData(response.todaysActivities))
            dispatch(getSummaryData(response.occuranceCounts))
            dispatch(getModes(response.modes))
            // dispatch(fetchScheduleFilter(date,'','','',''))

          }
        })
    })
  }
}

export const fetchScheduleTeacher = (callback) => {
  return (dispatch) => {
    const url = `/schedule-new/`
    return new Promise((resolve, reject) => {
      Api.get(url)
        .send((response, error) => {
          if (callback) {
            callback()
          }
          if (response != undefined) {
            dispatch(getSchedules(response.schedules))
            dispatch(getStdListFilter(response.standards))
            dispatch(getSubListFilter(response.subjects))
          }
        })
    })
  }
}

export const fetchScheduleStudent = (callback) => {
  return (dispatch) => {
    const url = `/schedule-new/`
    return new Promise((resolve, reject) => {
      Api.get(url)
        .send((response, error) => {
          if (callback) {
            callback()
          }
          if (response != undefined) {
            dispatch(getSchedules(response.schedules))

          }
        })
    })
  }
}

export const fetchTimetableData = (stdIdFilter, callback, date) => {
  return (dispatch, getState) => {
    const url = `/schedule-new/timetable?classId=${stdIdFilter ? stdIdFilter : ''}`
    return new Promise((resolve, reject) => {
      Api.get(url).params({ date: date ? date : moment().format('YYYY-MM-DD') })
        .send((response, error) => {
          if (callback) {
            callback()
          }
          if (response != undefined) {
            //   console.log("response",response)
            dispatch(getTimetable(response))
          }
        })
    })
  }
}

// `skipListUpdate` lets a caller read the filter-schedule response (e.g. just for
// counts, like scheduleAdmin.js's today-stats widget) without dispatching it into the
// shared scheduleList — that dispatch is what every card list (Ongoing/Scheduled/
// Completed/Cancelled) renders from, so a background stats-only call racing against a
// real filter change would otherwise silently clobber whatever date the user actually
// has selected, whichever response happens to resolve last.
export const fetchScheduleFilter = (date, topic, std, sub, callback, endDate = null, skipListUpdate = false) => {
  return (dispatch, getState) => {
    var dateCurrent = moment().format('YYYY-MM-DD')
    let params = {
      date: date ? date : dateCurrent,
      search: topic ? topic : '',
      subjectIds: sub && sub.length != 0 ? sub : [],
      classIds: std && std.length != 0 ? std : [],
    }
    if (endDate) {
      params = {
        startDate: date ? date : dateCurrent,
        endDate: endDate,
        search: topic ? topic : '',
        subjectIds: sub && sub.length != 0 ? sub : [],
        classIds: std && std.length != 0 ? std : [],
      }
    }
    const url = `/schedule-new/filter-schedule`
    return new Promise((resolve, reject) => {
      Api.get(url).params(params)
        .send((response, error) => {
          if (response != undefined) {
            if (!skipListUpdate) dispatch(getSchedules(response))
            if (callback) callback(response)
          } else {
            if (callback) callback(null)
          }
        })
    })
  }
}

// /schedule-new/summary-data returns every class in the org unless it is told to narrow.
// A teacher holding no elevated privilege only ever sees their own classes - the same
// 'own' view scope that already decides ScheduleTeacher vs ScheduleAdmin in schedule.js -
// so that user's request carries teacherId and nobody else's does. viewScope rather than
// the Teacher role alone: Admin, Planner, AttendanceMarker and SuperAdmin all widen a
// teacher back to every class, and those send no teacherId, exactly as before.
//
// user.id is what goes in it. The frontend treats the teacher id and the user id as one
// namespace throughout - activeClass.teacherId === user.id above, and schedule.teacher.id
// === user.id in canMarkAttendanceFor - so there is no separate teacher-record id to send.
// `ownScope` is the caller stating outright that this request is for one teacher's own
// classes, and it is what ScheduleTeacher passes. Deriving it was not enough: viewScope
// reads user.role and looks for the literal string 'Teacher', while schedule.js routes a
// user to ScheduleTeacher off user.access ('schedule-teacher'). An account that reaches
// the teacher page without 'Teacher' spelled in its role list therefore came out as
// viewScope 'all' and asked for the whole organisation - which is what put the org's
// 250/231/60 on a single teacher's Overview cards. The page that can only ever show own
// classes should not have to infer that from role strings.
const withTeacherScope = (params, user, ownScope = false) => {
  const { viewScope } = getSchedulePermissions(user)
  if ((ownScope || viewScope === 'own') && user?.id != null) {
    return { ...params, teacherId: user.id }
  }
  return params
}

export const fetchScheduleStats = (startDate, endDate, callback, ownScope = false) => {
  return (dispatch, getState) => {
    const { user } = getState().session || {}
    const params = withTeacherScope({ startDate, endDate, type: 'month', compiled: true }, user, ownScope)
    Api.get('/schedule-new/summary-data').params(params).send((response) => {
      if (callback) callback(response || null)
    })
  }
}

export const fetchScheduleFilterTeacherandStudent = (date, search, classIds, callback, subjectIds, skipListUpdate = false) => {
  return (dispatch, getState) => {
    var dateCurrent = moment().format('YYYY-MM-DD')
    const parsedDate = date ? moment(date, ['DD/MM/YYYY', 'YYYY-MM-DD', 'DD MMM YYYY']) : null;
    let params = {
      date: parsedDate && parsedDate.isValid() ? parsedDate.format('YYYY-MM-DD') : dateCurrent,
      search: search ? search : '',
      classIds: classIds ? classIds : [],
      subjectIds: subjectIds ? subjectIds : []
    }
    const url = `/schedule-new/filter-schedule`
    return new Promise((resolve, reject) => {
      Api.get(url).params(params)
        .send((response, error) => {
          if (response != undefined) {
            if (!skipListUpdate) {
              dispatch(getSchedules(response))
            }
          }
          if (callback) {
            callback(response)
          }
          resolve(response)
        })
    })
  }
}

export const postEditOccurance = (objectOccurance, callback, successCallback) => {
  return (dispatch) => {
    const url = `/schedule-new/edit-occurance`
    return new Promise((resolve, reject) => {
      console.log("PAYLOAD BEING SENT TO EDIT-OCCURANCE:", JSON.stringify(objectOccurance));
      Api.patch(url, objectOccurance)
        .send((response, error) => {
          if (response != undefined) {
            console.log("res", response.type)
            if (response.show && response.show.type == 'error') {
              callback(response)
            }
            else {
              successCallback(response)
            }
          }
          else {
            callback()
          }
        })
    })
  }
}

export const deleteSchedule = (id) => {
  return (dispatch) => {
    const url = `/schedule-new/?scheduleId=${id}`
    return new Promise((resolve, reject) => {
      Api.delete(url)
        .send((response, error) => {
          if (response != undefined) {
            // This endpoint answers 200 even when it refuses the delete, putting the
            // reason in the body (e.g. {"show":{"type":"error","message":"Schedule
            // already deleted"}}). Api.send() only reads `show` to raise the toast -
            // it still hands the body back here - so resolving blindly told callers
            // the delete had worked and left them refreshing a list that hadn't
            // changed. Resolve WITH the body so the caller can tell the difference;
            // still resolve (not reject) so existing callers that ignore the value
            // keep their current behaviour.
            resolve(response)
            console.log(response)
          } else {
            reject()
          }
        })
    })
  }
}

export const cancelSchedule = (occurrenceId) => {
  return (dispatch) => {
    const url = `/schedule-new/cancel?id=${occurrenceId}`
    return new Promise((resolve, reject) => {
      Api.patch(url)
        .send((response, error) => {
          if (response != undefined) {
            console.log(response)
            resolve()
          }
          else {
            reject()
          }
        })
    })
  }
}

export const fetchSummaryData = (isMonthOrWeek, startDate, endDate, callback, ownScope = false) => {
  return (dispatch, getState) => {
    // This used to blank the bar graph before every request:
    //   dispatch(getSummaryData([]));
    // The bars vanished and then reappeared on each fetch, so any refresh - the
    // mount fetch after coming back from the video player, and every
    // apicall:scheduleHome emit from a publish/rename/delete in the drawer - read
    // as the graph reloading itself. Nothing needs the blank state: the graph's
    // own loading flag drives the spinner (see refreshSummaryData in
    // scheduleAdmin.js), and keeping the previous bars up until the new ones land
    // is what makes a refresh invisible instead of a flash.
    const { user } = getState().session || {}
    let params = withTeacherScope({
      type: isMonthOrWeek,
      startDate: startDate ? startDate : '',
      endDate: endDate ? endDate : ''
    }, user, ownScope)
    const url = `/schedule-new/summary-data`
    return new Promise((resolve, reject) => {
      Api.get(url).params(params)
        .send((response, error) => {
          if (callback) {
            callback();
          }
          if (response != undefined) {
            dispatch(getSummaryData(response))
          }
        })
    })
  }
}

export const setRecordCount = (val) => ({
  type: SET_RECORD_COUNT,
  val
})


export const joinClass = (id, callBack = null) => {
  return (dispatch, getState) => {
    const url = `/schedule-new/join-class?id=${id}`;
    const { user } = getState().session;
    const { streamId, roomboardData } = getState().broadcast;
    // Offline, as the browser itself reports it. Asked before the request rather than after
    // because there is nothing useful on the other side of the wait: the join would sit on a
    // connection that cannot be made, and a classroom is not somewhere to arrive half-joined.
    // Both join surfaces — the ongoing-class card and the teacher/student list — come
    // through here, so this is the one place that covers them.
    if (typeof navigator !== 'undefined' && navigator.onLine === false) {
      if (callBack) callBack();
      dispatch(setBroadcastLoader(false));
      dispatch(setJoinLoader(false));
      Notification.error('Error', 'You are offline. Check your internet connection and try joining again.');
      return Promise.reject(new Error('offline'));
    }
    dispatch(setBroadcastLoader(true));
    dispatch(setRecordCount(0))
    return new Promise((resolve, reject) => {
      Api.patch(url)
        .send(async (response, error) => {
          if (callBack) {
            callBack();
          }
          if (response != undefined && response?.show?.type != 'error') {
            let isScheduledTeacher = response.occurance?.teacherId === user.id
            dispatch(setScheduledTeacher(isScheduledTeacher))
            dispatch(updateActiveClass(response));
            dispatch(setRecordCount(response.occurance?.recordCount))
            dispatch(setRightView(false));
            dispatch(setRightViewType(''));
            dispatch(updateBroadcastStudentList(response?.students || []));
            dispatch(copyChats(response.chats?.group || [], response.chats?.private || [], user));
            dispatch(setLocalRecordingName('abc', 'abc'))
            dispatch(updateUnreadCount('clear'))
            if (response.chats) {
              dispatch(updateUnreadCount('group', response.chats.groupChatUnseenCount))
              response.chats.privateCount = {}
              response.chats.privateUnseenCount.forEach((item) => {
                response.chats.privateCount[item.userId] = item.count
              })
              dispatch(updateUnreadCount('privateFull', response.chats.privateCount))
            }
            if (!(streamId in roomboardData)) {
              dispatch(setRoomBoardData(streamId, {
                roomdata: {
                  "1": [],
                  "2": [],
                  "3": [],
                }
              }
              ))
            }
            dispatch(setJoinLoader(false));
            resolve();
          }
          else {
            // Refused or failed. Both loaders were raised on the way in and only the success
            // path lowered them, so the schedule was left spinning behind the error snackbar.
            dispatch(setBroadcastLoader(false));
            dispatch(setJoinLoader(false));
            // Two different failures arrive here and only one of them has already been
            // reported. A refusal carries a body, and Api.js reads the reason out of it and
            // shows it — "you have already joined from BROWSER", and the like. A request that
            // never reached the server carries no body at all, which is the one case Api.js
            // has no message for: it only speaks when there is a response to quote. That was
            // the silent failure here — the connection dropped between opening the schedule
            // and pressing Join, the spinner stopped, and nothing else happened.
            if (response === undefined) {
              Notification.error('Error', 'Could not reach the classroom. Check your internet connection and try again.');
            }
            reject();
          }
        })
    })
  }
}

// join-class writes a broadcast_user_states row for (room, user, device) and refuses the
// next join while that row is still there — "You have already joined from BROWSER". The web
// client never removed it, so one join locked the user out of that class for good. DELETE
// /schedule-new/broadcast-user-state?occuranceId= is the only thing that erases the row, so
// every path out of a class has to come through here.
//
// Deliberately quiet, and it never rejects: this runs while the user is already on their way
// out, a failure is nothing they can act on, and leaving must not be blocked by the
// bookkeeping that trails it.
//
// beacon is the tab-closing case. Api.send() debounces 50ms and then issues a normal XHR,
// both of which a closing document cancels; fetch(keepalive) is handed to the browser to
// finish on its own after the page is gone. Same URL, same headers, different transport.
//
// Best effort, not a guarantee: a cross-origin DELETE carrying an Authorization header is
// never a simple request, and the OPTIONS preflight in front of it is not itself keepalive,
// so a tab closing on a cold preflight cache can still leave the row behind. Every in-app
// exit — Leave, a route change — goes out through the branch above and is reliable. Closing
// the tab is the residual, and closing it for good needs the row to expire server-side.
export const leaveBroadcast = (occuranceId, { beacon = false } = {}) => (dispatch, getState) => {
  const state = getState();
  const id = occuranceId ?? state.schedule?.activeClass?.occurance?.id ?? state.liveClass?.confId;
  if (id === undefined || id === null || id === '') return Promise.resolve();

  const url = `/schedule-new/broadcast-user-state?occuranceId=${id}`;
  if (!beacon) {
    return new Promise((resolve) => {
      Api.delete('/schedule-new/broadcast-user-state')
        .suppressSnackbar()
        .params({ occuranceId: id })
        .send(() => resolve());
    });
  }

  const headers = {
    Authorization: `Bearer ${state.session?.user?.accessToken ?? ''}`,
    orgurl: Api._headers?.orgurl ?? '',
    version: Api._headers?.version ?? '',
  };
  const full = `${Api._base_url}/api${url}`;
  try {
    // keepalive is what outlives the document. Firefox only grew it in 126, so anything
    // older falls through to a synchronous XHR — deprecated, and the one context where it
    // is still the right tool.
    if (typeof fetch === 'function') {
      fetch(full, { method: 'DELETE', headers, keepalive: true }).catch(() => {});
    } else {
      const xhr = new XMLHttpRequest();
      xhr.open('DELETE', full, false);
      Object.keys(headers).forEach((key) => xhr.setRequestHeader(key, headers[key]));
      xhr.send();
    }
  } catch (error) {
    // the tab is closing — there is nobody left to tell
  }
  return Promise.resolve();
};

export const getJoinUsers = () => {
  return (dispatch, getState) => {
    let { roomIds } = getState().schedule
    const url = `https://2damuur84g.execute-api.ap-south-1.amazonaws.com/prod/getjoinedusers`
    return new Promise((resolve, reject) => {
      axios.post(url,
        {
          operation: "list",
          data: {
            roomIds: roomIds
          }
        })
        .then((response) => {
          if (response != undefined) {
            dispatch(getOnlineUser(response.data))
          }
        })

    })
  }
}



export const setSubject = (subId) => ({
  type: SET_SUBJECT,
  subId
})

export const setClass = (classId) => ({
  type: SET_CLASS,
  classId
})

export const setTeacher = (teacherId) => ({
  type: SET_TEACHER,
  teacherId
})

export const setStartTime = (time) => ({
  type: SET_START_TIME,
  time
})

export const setEndTime = (time) => ({
  type: SET_END_TIME,
  time
})

export const setSartDate = (date) => ({
  type: SET_START_DATE,
  date
})

export const setEndDate = (enddate) => ({
  type: SET_END_DATE,
  enddate
})

export const setMode = (mode) => ({
  type: SET_MODE,
  mode
})

export const setWeekDays = (week) => ({
  type: SET_WEEKDAYS,
  week
})

export const getSubList = (subList) => ({
  type: GET_SUB_LIST,
  subList
})

export const getClassList = (classList) => ({
  type: GET_CLASS_LIST,
  classList

})

export const getTeacherList = (teacherList) => ({
  type: GET_TEACHER_LIST,
  teacherList
})

export const getSchedules = (schedule) => ({
  type: GET_SCHEDULE_LIST,
  schedule
})

export const getSummaryData = (summaryData) => ({
  type: GET_SUMMARY_DATA,
  summaryData
})

export const getTimetable = (timetableData) => ({
  type: GET_TIMETABLE_DATA,
  timetableData
})

export const getStdListFilter = (stdListFilter) => ({
  type: GET_STD_LIST_FILTER,
  stdListFilter
})

export const getTodayactivitiesData = (data) => ({
  type: GET_TODAY_ACTIVITIES_DATA,
  data
})

export const getSubListFilter = (sub) => ({
  type: GET_SUB_LIST_FILTER,
  sub
})

export const setScheduleIdDelete = (id) => ({
  type: SET_SCHEDULE_ID,
  id
})

export const setScheduleTimeTable = (item) => ({
  type: SET_SCHEDULE_TIMETABLE,
  item
})

export const setMonthOrWeek = (isMonthOrWeek) => ({
  type: SET_MONTH_OR_WEEK,
  isMonthOrWeek
})

export const setStartDateSchedule = (date) => ({
  type: SET_START_DATE_SCHEDULE,
  date
})

export const setEndDateSchedule = (date) => ({
  type: SET_END_DATE_SCHEDULE,
  date
})


export const setTabType = (tab) => ({
  type: SET_TAB_TYPE,
  tab
})

export const setStdFilterTimeTable = (std) => ({
  type: SET_STD_FILTER_TIMETABLE,
  std
})

export const updateError = (error) => ({
  type: UPDATE_ERROR,
  error
})

export const setBroadcastSelectedClassroom = (newClass) => ({
  type: SET_BROADCAST_SELECTED_CLASSROOM,
  newClass
})

export const setRoomIds = (roomIds) => ({
  type: SET_ROOM_IDS,
  roomIds
})

export const getOnlineUser = (users) => ({
  type: GET_ONLINE_USER,
  users
})

export const setAccess = (bool) => ({
  type: SET_ACCESS,
  bool
})

export const setDelOrCancel = (delOrCancel) => ({
  type: SET_DEL_OR_CANCEL,
  delOrCancel

})

export const updateBroadcastStudentList = (data) => ({
  type: UPDATE_BROADCAST_STUDENT_LIST,
  data
})

export const setCurrentDate = (currentDate) => ({
  type: SET_CURRENT_DATE,
  currentDate
})

export const getModes = (modes) => ({
  type: GET_MODES,
  modes
})

export const setTeacherfilter = (teacher) => ({
  type: SET_TEACHER_FILTER,
  teacher
})

export const setClassFilter = (classes) => ({
  type: SET_CLASS_FILTER,
  classes
})

export const setSubFilter = (sub) => ({
  type: SET_SUB_FILTER,
  sub
})

export const setJoinLoader = (bool) => ({
  type: SET_JOIN_LOADER,
  bool
})


// schedule attendance


// Minutes a student has to be in the class before they count as present. It is
// minAttendancePercentageStudent (set in /attendance-requirements) of the class's
// scheduled length, so it varies per class. Returns null when either half of that
// is unavailable, so callers can tell "not configured" from "zero minutes".
export const getAttendanceThresholdMins = (occurance, percentage) => {
  const pct = parseFloat(percentage)
  if (!Number.isFinite(pct) || pct <= 0) return null
  const start = occurance?.startTime
  const end = occurance?.endTime
  if (!start || !end) return null
  const classMins = moment.duration(
    moment(end, 'HH:mm:ss').diff(moment(start, 'HH:mm:ss'))
  ).asMinutes()
  if (!Number.isFinite(classMins) || classMins <= 0) return null
  return Math.ceil((classMins * pct) / 100)
}

export const setAttendanceThreshold = (thresholdMins) => ({
  type: SET_ATTENDANCE_THRESHOLD,
  thresholdMins
})

export const fetchStudentListData = (id) => {

  return (dispatch, getState) => {
    // Clear previous selections immediately to avoid flashing previous student selections
    dispatch(setSelectedStudentsClear())
    // Clear previous student data so UI does not render stale students while fetching
    dispatch(setStudentData([]))
    // Preserve the current cardData (set earlier by markAttendanceHandler) so the UI
    // can show whether attendance was already marked (edit mode) while fetching.
    const { cardData } = getState().schedule || {}
    dispatch(setSubjectData(cardData || {}))
    dispatch(setInitialSummary({}))
    // show loading spinner for student list to prevent flashes
    dispatch(setStudentListLoading(true))
    let selectedId = id || getState().schedule.selectedId
    let params = {
      occurrenceId: selectedId,
      occuranceId: selectedId, // Backward compatibility
    }
    const url = `/attendancev2/student-list`
    return new Promise((resolve, reject) => {
      Api.get(url).params(params)
        .send((response, error) => {
          if (response != undefined) {
            dispatch(setStudentData(response?.students))
            // Prepare the new occurance data, merging with what we already have.
            const apiOccurance = response?.occurance || {}
            const mergedOccurance = { ...(cardData || {}), ...apiOccurance }

            // Validate if the API actually returned useful standards info.
            // Some APIs return [ { std: 'undefined', section: 'undefined' } ] which we must ignore.
            const validApiStandards = (apiOccurance.standards || []).filter(item =>
              (item?.std && item?.std !== 'undefined') || (item?.section && item?.section !== 'undefined')
            )

            // If the API didn't provide valid standards, but we have them in cardData, use the ones from cardData.
            if (cardData?.standards?.length && validApiStandards.length === 0) {
              mergedOccurance.standards = cardData.standards
            }
            dispatch(setSubjectData(mergedOccurance))

            // The present/absent cut-off is a percentage of this class's length, so it
            // can only be worked out once we know both the class times (mergedOccurance)
            // and the configured percentage (attendance settings slice).
            const requirementPct = getState().attendanceNew?.getattendanceRequirement?.minAttendancePercentageStudent
            const thresholdMins = getAttendanceThresholdMins(mergedOccurance, requirementPct)
            dispatch(setAttendanceThreshold(thresholdMins))

            dispatch(setInitialSummary({
              totalStudents: response?.totalStudents,
              presentCount: response?.presentCount,
              absentCount: response?.absentCount
            }))
            if (response?.totalStudents === response?.presentCount) {
              dispatch(setCheckBoxState(true))
            } else {
              dispatch(setCheckBoxState(false))
            }
            dispatch(setAllFalse(thresholdMins, mergedOccurance?.mode))
            // loading complete
            dispatch(setStudentListLoading(false))
            console.log('studentList', response)
          }
          else {
            // ensure loading flag is cleared on error
            dispatch(setStudentListLoading(false))
          }
        })
    })
  }
}

export const setInitialSummary = (value) => ({
  type: SET_INITIAL_SUMMARY,
  value
})

export const setStudentData = (value) => ({
  type: SET_STUDENT_DATA,
  value
})

export const setSubjectData = (value) => ({
  type: SET_SUBJECT_DATA,
  value
})

export const setSelectedStudents = (id) => ({
  type: SET_SELECTED_STUDENTS,
  id,

})

export const setSelectedStudentsClear = () => ({
  type: SET_SELECTED_STUDENTS_CLEAR,
})

export const setCheckBoxState = (bool) => ({
  type: SET_CHECKBOX_STATE,
  bool
})

export const setSelectAll = () => ({
  type: SET_SELECT_ALL,

})

// `mode` is the class's own mode, carried so the seed can refuse to pre-mark an
// Others class - see the SET_ALL_FALSE reducer.
export const setAllFalse = (thresholdMins, mode) => ({
  type: SET_ALL_FALSE,
  thresholdMins,
  mode,
})

export const setSelectedId = (id) => ({
  type: SET_SELECTED_ID,
  id
})

export const setPresentStudents = (id) => ({
  type: SET_PRESENT_STUDENTS,
  id
})

export const setCardData = (value) => (dispatch, getState) => {
  const { user } = getState().session || {};
  // Update state regardless of role so attendance page gets correct metadata (batch/standards).
  // Restriction for admin drawer is handled in the UI components (scheduledClass.js).

  dispatch({
    type: SET_CARD_DATA,
    value,
  });
  // Also seed subjectAttendanceData immediately so the attendance page
  // can render 'EDIT' / attendanceMarked state without waiting for the API.
  try {
    dispatch(setSubjectData(value))
  } catch (e) {
    // noop - defensive
  }
}

export const setTeacherDate = (key, value) => ({
  type: SET_TEACHER_DATE,
  key,
  value
})

// selectedStudents is an object keyed by studentId, and object keys are strings by
// definition - so studentIds went out as ["276"] where the DTO wants [276]. This is a
// JSON POST body (Api.js sends params as axios request.data), so the string survives
// the wire as a string and the DTO rejects it with a bare "Something went wrong".
// Anything non-numeric is passed through untouched rather than coerced to NaN, which
// would serialise to null and lose the value outright.
const toNumericId = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : value;
};

export const postLogOfflineAttendance = (callBack = null) => {
  const url = `/attendancev2/log-offline-attendance`;
  return (dispatch, getState) => {
    const { selectedId, selectedStudents } = getState().schedule
    const output = [];
    Object.keys(selectedStudents || {}).forEach(key => {
      if (selectedStudents[key]) {
        output.push(toNumericId(key));
      }
    })

    const params = {
      occurrenceId: toNumericId(selectedId),
      occuranceId: toNumericId(selectedId), // Backward compatibility
      studentIds: output
    }
    return new Promise((resolve, reject) => {
      Api.post(url).params(params)
        .send((response, error) => {
          if (response) {
            // Optimistically update the local scheduleList so the card instantly shows "EDIT ATTENDANCE"
            const currentScheduleList = getState().schedule.scheduleList || {};
            const updatedScheduleList = { ...currentScheduleList };
            ['ongoing', 'completed', 'scheduled', 'cancelled'].forEach(category => {
              if (updatedScheduleList[category]) {
                updatedScheduleList[category] = updatedScheduleList[category].map(item => {
                  const isMatch = (
                    String(item?.id) === String(selectedId) ||
                    String(item?.occurrenceId) === String(selectedId) ||
                    String(item?.scheduleId) === String(selectedId) ||
                    String(item?.schedule?.id) === String(selectedId)
                  );
                  if (isMatch) {
                    return {
                      ...item,
                      attendanceMarked: true,
                      attendanceData: {
                        ...(item.attendanceData || {}),
                        presentCount: output.length,
                        studentCount: (item.attendanceData && item.attendanceData.studentCount) || Object.keys(selectedStudents || {}).length
                      }
                    };
                  }
                  return item;
                });
              }
            });
            dispatch({ type: GET_SCHEDULE_LIST, schedule: updatedScheduleList });

            // Also update subjectAttendanceData and cardData so any attendance views reflect marked attendance immediately
            const currentSubjectData = getState().schedule.subjectAttendanceData || {};
            dispatch(setSubjectData({
              ...currentSubjectData,
              attendanceMarked: true
            }));

            const currentCardData = getState().schedule.cardData;
            if (currentCardData) {
              dispatch({
                type: SET_CARD_DATA,
                value: {
                  ...currentCardData,
                  attendanceMarked: true
                }
              });
            }

            EventRegister.emit('apicall:scheduleHome');
          }

          if (callBack) {
            callBack()
          }
          resolve();
        });
    });
  };
}

export const pollAttendance = () => (
  dispatch,
  getState,
) => {
  const { user } = getState().session;
  const { broadcastSelectedClass } = getState().schedule;
  const params = {
    userId: user.id,
    orgUrl: user.org.url,
    occurrenceId: broadcastSelectedClass.id,
    occuranceId: broadcastSelectedClass.id // Backward compatibility
  }
  return Api.post('/attendancev2/log-duration')
    .params(params)
    .send((response, error) => {
      if (typeof response !== 'undefined') {

      }
    });
};

export const setPageToggle = (value) => ({
  type: SET_PAGE_TOGGLE,
  value
})

export const fetchSubscriptionAlert = (res) => ({
  type: FETCH_SUBSALERT_DATA,
  res
})

export const setSubscriptionModal = (res) => ({
  type: SET_SUBSCRIPTION_MODAL,
  res
})

export const subscriptionAlert = () => (
  dispatch,
  getState,
) => {
  const { } = getState().schedule;
  const params = {}
  let intervalId = null
  return Api.get('/schedule-new/subscription/user-hours-data')
    .params(params)
    .send((response, error) => {
      if (response !== 'undefined') {
        // if( response?.status === "Fetching" || response?.status === "Invalid" ) {
        //     intervalId = setInterval(() => {
        //       console.log('calling')
        //       dispatch(subscriptionAlert())
        //     }, 1000); 
        //   } 

        // if(response?.status === "Error Fetching"){
        //     notification.error("Error in fetching broadcast user hours data")
        // }
        dispatch(fetchSubscriptionAlert(response))
        console.log('rest', response)
      }
    });
};

export const setConferenceJoinLoader = (bool) => ({
  type: SET_CONFERENCE_JOIN_LOADER,
  bool
});

export const studentStandardsFilter = res => ({
  type: STUDENT_STANDARD_FILTER,
  res
})

export const fetchStudentStandards = (callback = null, suppressLogout = false) => {
  return (dispatch, getState) => {
    const { user } = getState().session
    const url = `/user/studentStandards`;
    // suppressLogout: topBar's "MY ACCOUNT" click probes this endpoint to
    // check a student's live assignment status, and a course-less student
    // hitting it can legitimately 401 - that's not an invalid session, so
    // let the caller decide what to do instead of the global interceptor
    // forcing a logout/redirect first.
    const request = Api.get(url).params({ userId: user.id });
    if (suppressLogout) {
      request.suppressLogout();
    }
    return (
      request.send((response, error) => {
        dispatch(studentStandardsFilter(response));
        if (callback) callback(response, error);
      })
    )
  }
}

export const setLiveStreamUrl = (val) => ({
  type: SET_LIVE_STREAM_URL,
  val
})



